import React, { useEffect } from "react";

import { connect } from "react-redux";

// Import Routes all
import { userRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";

// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

//import fakeBackend from "./helpers/AuthType/fakeBackend";
import {
  AuthenticatedTemplate,
  MsalProvider,
  useMsal,
} from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { getUserRoles } from "./store/actions";
import { scheduleTokenRefresh } from "./helpers/tokenRefreshService";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Activating fake backend
//fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const MainContent = ({ layout, getUserRoles, userRoles }) => {
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount === null) {
      instance
        .loginRedirect({
          ...loginRequest,
          prompt: "create",
        })
        .catch((error) => console.log(error));
    } else {
      getUserRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (accounts.length > 0) {
      scheduleTokenRefresh(instance, accounts[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts]);

  return (
    <>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AuthenticatedTemplate>
          <Routes>
            {userRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={
                  <Authmiddleware
                    layout={Layout}
                    userRoles={userRoles}
                    isAuthProtected={route.isAuthProtected} // True se necessitar de Login
                  >
                    <route.component />
                  </Authmiddleware>
                }
              />
            ))}
          </Routes>
        </AuthenticatedTemplate>
      </BrowserRouter>
    </>
  );
};

const App = ({ instance, ...props }) => {
  return (
    <React.Fragment>
      <MsalProvider instance={instance}>
        <MainContent {...props} />
      </MsalProvider>
    </React.Fragment>
  );
};

const mapStateToProps = ({ RolesReducer: { userRoles }, Layout }) => ({
  userRoles,
  layout: Layout,
});

const mapDispatchToProps = {
  getUserRoles: getUserRoles.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
